import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-teaching',
  templateUrl: './teaching.component.html',
  styleUrls: ['./teaching.component.css']
})
export class TeachingComponent implements OnInit {
  Submitted: boolean = false;
  BookTitleList = [];
  ChapterHeadingList = [];
  ChapterTopicList = [];
  SearchChapterHeadingList = [];
  SearchChapterTopicList = [];
  ChapterContentList = [];

  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;

  constructor(private learningservice: LearningService, private LookupService: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService, private _sanitizer: DomSanitizer) { }

  SearchModel = {
    BookTitleID: 0,
    ChapterID: 0,
    TopicID: 0,
    ClassID: 0,
    SectionID: 0,
    CurrentIndex: 0,
    PageSize: 20,
  };

  ClearSearch() {
    this.SearchModel.BookTitleID = 0;
    this.SearchModel.ChapterID = 0;
    this.SearchModel.TopicID = 0;
    this.SearchModel.TopicID = 0;
    this.SearchModel.ClassID = 0;
    this.SearchModel.SectionID = 0;
    this.TeachingList = [];
    this.PreviousTeachingList = [];
    this.pageSizes();
  }
  Content: '';
  LearningModel = {
    TeachingID: 0,
    ClassSectionID: "",
    ClassID: 0,
    SectionID: 0,
    SubjectID: 0,
    ContentID: 0,
    BookTitleID: 0,
    ChapterID: 0,
    TopicID: 0,
    StaffID: 0,
    ContentTitle: '',
    YouTubeUrls: '',
    IsActive: true,
    IsShared: false,
  };

  Clear() {
    this.LearningModel.TeachingID = 0;
    this.LearningModel.ContentID = 0;
    this.LearningModel.BookTitleID = 0;
    this.LearningModel.ChapterID = 0;
    this.LearningModel.TopicID = 0;
    this.LearningModel.StaffID = 0;
    this.LearningModel.ClassID = 0;
    this.LearningModel.SectionID = 0;
    this.LearningModel.YouTubeUrls = '';
    this.LearningModel.ClassSectionID = '';
    this.Content = '';
    this.Submitted = false;
  }

  Edit(obj) {
    this.LearningModel.TeachingID = obj.TeachingID;
    this.LearningModel.ClassSectionID = obj.ClassSectionID;
    this.SetID();
    this.LearningModel.StaffID = obj.StaffID;
    this.LearningModel.BookTitleID = obj.BookTitleID;
    this.GetChapterHeading();
    this.LearningModel.ChapterID = obj.ChapterID;
    this.GetChapterTopic();
    this.LearningModel.TopicID = obj.TopicID;
    this.GetTopicContent();
    this.LearningModel.ContentID = obj.ContentID;
    this.LearningModel.YouTubeUrls = obj.YouTubeUrls;
    this.LearningModel.IsShared = obj.IsShared;
    this.Content = obj.Description;
    this.LearningModel.IsActive = obj.IsActive;

  }

  ValidityState() {
    return this.LearningModel.BookTitleID == 0 || this.LearningModel.TopicID == 0 || this.LearningModel.ContentID == 0 || this.LearningModel.StaffID == 0;
  }

  SelectedFileForUpload: any;
  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };
  MarkShareTeachingResourse(item) {
    this.ContentModel.TeachingResourceID = item.TeachingResourceID;
    this.ContentModel.IsShared = item.IsShared == true ? false : true;
    this.spinnerService.show();
    this.learningservice.MarkShareTeachingResourse(this.ContentModel.TeachingResourceID,this.ContentModel.IsShared).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllTeachingResource(item.TeachingID);
      }
     
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  };
  
  TeachingList = [];
  GetAllLearningTeaching() {
    this.spinnerService.show();
    this.SearchModel.CurrentIndex = this.currentPage;
    this.SearchModel.PageSize = this.pageSize;
    this.learningservice.GetAllTeaching(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.TeachingList = data.TeachingList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
      this.recordCount = 0;
      if (data.TeachingList != null && data.TeachingList.length > 0) {
        this.recordCount = data.TeachingList[0].RecordCount;
      }
      this.numberOfPages();
    });
  };

  MarkActiveLearningTeaching(item) {
    this.LearningModel.TeachingID = item.TeachingID;
    this.LearningModel.IsActive = item.IsActive == true ? false : true;
    this.spinnerService.show();
    this.learningservice.MarkActiveLearningTeaching(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllLearningTeaching();
      }

      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  };


  ContentModel = {
    TeachingResourceID: 0,
    TeachingID: 0,
    ResourceType: '0',
    ContentTitle: '',
    ResourcePath: '',
    IsShared: false,
    ResourceName: '',
  };

  GetContent(item) {
    this.ContentModel.TeachingID = item.TeachingID;
    this.ContentModel.ResourceType = '0';
    this.ContentModel.TeachingResourceID = 0;
    this.ContentModel.ResourcePath = '';
    this.ContentModel.ResourceName = '';
    this.ContentModel.IsShared = false;
    this.ContentModel.ContentTitle = item.ContentTitle;
    this.GetAllTeachingResource(this.ContentModel.TeachingID);

  }

  

  
  DeleteTeachingResource(item) {
    this.ContentModel.TeachingResourceID = item.TeachingResourceID;
    if (confirm("Are you sure to delete this resource !")) {
      this.spinnerService.show();
      this.learningservice.DeleteTeachingResource(JSON.stringify(this.ContentModel)).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetAllTeachingResource(item.TeachingID);
          this.ContentModel.TeachingResourceID=0;
        }

        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }

  };

  safeSrc: SafeResourceUrl;
  embedURL(url) {

    let stringToSplit = url;
    let x = stringToSplit.split("https://www.youtube.com/watch?v=");
    var safeSrc = "https://www.youtube.com/embed/" + x[1] + "?loop=1" + "&origin=1&rel=1&showinfo=1"
    return this._sanitizer.bypassSecurityTrustResourceUrl(safeSrc);



  }

  EditResource(item) {
    this.ContentModel.TeachingResourceID = item.TeachingResourceID;
    this.ContentModel.ResourceType = item.ResourceType;
    this.ContentModel.ResourcePath = item.ResourcePath != null ? item.ResourcePath : '';
    this.ContentModel.IsShared = item.IsShared;
    this.ContentModel.ResourceName = item.ResourceName;
  }
  ngOnInit() {
    this.GetClass();
    this.GetSection();
    this.GetClassSection();
    this.GetBookTitle();
    this.GetSearchChapterHeading();
    this.GetSearchChapterTopic();
  }
  ClassList = [];
  GetClass() {
    this.LookupService.GetLookupsList('LPClass', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  }
  GetBookTitle() {
    this.LookupService.GetLookupsList('LearningBookTitle', '').subscribe((data: any) => {
      this.BookTitleList = data.LookupItems;
    });
  }
  ClassSectionList: any;
  GetClassSection() {
    this.LookupService.GetLookupsList('STClassSection', '').subscribe((data) => {
      this.ClassSectionList = data.LookupItems;

    });

  };
  SetID() {
    this.LearningModel.ClassID = 0;
    this.LearningModel.SectionID = 0;
    if (this.LearningModel.ClassSectionID != "") {
      var strClassSectionID = this.LearningModel.ClassSectionID.split('-');
      this.LearningModel.ClassID = parseInt(strClassSectionID[0]);
      this.LearningModel.SectionID = parseInt(strClassSectionID[1]);
      this.GetSubjectBookTitle();
      this.GetSubjectTeacher();
    }
  }
  SectionList = [];
  GetSection() {
    this.SearchModel.SectionID = 0;
    var ItemBO = {
      'ItemID': this.SearchModel.ClassID
    }
    this.LookupService.GetLookupsList('LPSection', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
    });
  }

  SubjectBookTitleList = [];
  GetSubjectBookTitle() {
    this.LearningModel.ChapterID = 0;
    var ItemBO = {
      'ItemID': this.LearningModel.ClassID
    }
    this.LookupService.GetLookupsList('SubjectBookTitle', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SubjectBookTitleList = data.LookupItems;
    });
  }

  SubjectTeacherList = [];
  GetSubjectTeacher() {
    this.LearningModel.StaffID = 0;
    var ItemBO = {
      'ItemID': this.LearningModel.ClassID,
      'ItemID1': this.LearningModel.SectionID
    }
    this.LookupService.GetLookupsList('AllClassSubjectTeacher', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SubjectTeacherList = data.LookupItems;
    });
  }
  GetChapterHeading() {
    this.LearningModel.ChapterID = 0;
    var ItemBO = {
      'ItemID': this.LearningModel.BookTitleID
    }
    this.LookupService.GetLookupsList('ChapterHeading', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ChapterHeadingList = data.LookupItems;
    });
  }

  GetChapterTopic() {
    this.LearningModel.TopicID = 0;
    var ItemBO = {
      'ItemID': this.LearningModel.ChapterID
    }
    this.LookupService.GetLookupsList('ChapterTopic', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ChapterTopicList = data.LookupItems;
    });
  }
  TopicContentList = [];
  GetTopicContent() {
    this.LearningModel.ContentID = 0;
    var ItemBO = {
      'ItemID': this.LearningModel.TopicID
    }
    this.LookupService.GetLookupsList('TopicContent', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.TopicContentList = data.LookupItems;
    });
  }
  GetSearchChapterHeading() {
    this.SearchModel.ChapterID = 0;
    this.SearchModel.TopicID = 0;
    this.ChapterContentList = [];
    var ItemBO = {
      'ItemID': this.SearchModel.BookTitleID
    }
    this.LookupService.GetLookupsList('ChapterHeading', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SearchChapterHeadingList = data.LookupItems;
    });

  }

  GetSearchChapterTopic() {
    this.SearchModel.TopicID = 0;
    this.ChapterContentList = [];
    var ItemBO = {
      'ItemID': this.SearchModel.ChapterID
    }
    this.LookupService.GetLookupsList('ChapterTopic', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SearchChapterTopicList = data.LookupItems;
    });

  }


  // Paging

  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages() {
    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage() {
    this.currentPage = this.currentPage + 1;
  }

  pageSizes() {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;
  }


  // Previous Session Teaching
  
  PreviousTeachingList = [];
  GetPreviousTeaching() {
    this.spinnerService.show();
    this.learningservice.GetPreviousTeaching(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.PreviousTeachingList = data.PreviousTeachingList;
       this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });
  };

  ImportLearningTeaching() {
   if (confirm("Are you sure to import previous session teaching !")) {
      this.spinnerService.show();
      this.learningservice.ImportLearningTeaching(JSON.stringify(this.PreviousTeachingList)).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetPreviousTeaching();          
        }

        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }

  };


  TeachingResourceList = [];
  GetAllTeachingResource(TeachingID) {
    this.spinnerService.show();
    this.learningservice.GetAllTeachingResource(TeachingID).subscribe((data: any) => {
      this.TeachingResourceList = data.TeachingResourceList;
      if (this.TeachingResourceList != null) {
        for (var i = 0; i < this.TeachingResourceList.length; i++) {
          this.TeachingResourceList[i].YouTubeUrls = this._sanitizer.bypassSecurityTrustResourceUrl(this.TeachingResourceList[i].YouTubeUrls);
        }

      }
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });
  };


  ClearResource(){
    this.TeachingResourceList=[]; 
  }

 
}





